import { advisorsList } from "./advisors"
import type { Advisor } from "../types"

/** Section copy ported from the `advisors` i18n namespace. */
export const sectionCopy = {
  all: { title: "All advisors" },
  recommended: {
    title: "Recommended for you",
    subtitle:
      "Based on your zodiac and preferences, these advisors may have exactly the insight you need",
  },
  accurate: {
    title: "Most accurate",
    subtitle:
      "These advisors have a reputation for providing straight answers with real, helpful insight",
  },
  bestInLove: {
    title: "Best in love readings",
    subtitle:
      "These experts know how to get to the heart of it - whether it’s about your current relationship, an ex, or someone you haven’t met yet",
  },
  topRated: {
    title: "Top rated",
    subtitle: "The ultimate list of top-rated psychics, trusted by thousands over the years",
  },
  advisorOTD: {
    title: "Advisor of the day",
    subtitle: "We select the advisor of the day based on celestial movements and their strengths",
  },
}

/** Curated subsets, mirroring the index picks used in the source V4 components. */
export const recommendedAdvisors: Advisor[] = [
  advisorsList[6],
  advisorsList[7],
  advisorsList[10],
  advisorsList[3],
  advisorsList[11],
]

export const accurateAdvisors: Advisor[] = advisorsList.filter((a) => a.rating >= 4.7)

export const bestInLoveAdvisors: Advisor[] = [
  advisorsList[9],
  advisorsList[8],
  advisorsList[12],
  advisorsList[1],
  advisorsList[2],
]

export const topRatedAdvisors: Advisor[] = [
  advisorsList[8],
  advisorsList[1],
  advisorsList[12],
  advisorsList[9],
  advisorsList[2],
]

export type AdvisorAdType = "dream" | "moon"

export const advisorAdsCopy: Record<
  AdvisorAdType,
  { title: string; subtitle: string; message: string }
> = {
  dream: {
    title: "Did you have a vivid dream today?",
    subtitle: "Get clarity! Our experts decode the signs for you",
    message:
      "I can help you uncover the hidden meaning behind it. Let me interpret the signs and reveal their message — what did you see in your dream?",
  },
  moon: {
    title: "What’s the Moon Telling You?",
    subtitle: "Discover the power of today’s moon phase",
    message: "I’ll reveal how today’s moon phase impacts you. What’s on your mind?",
  },
}

export const moonPresets = [
  "What’s today’s moon phase?",
  "How does the moon affect?",
  "Is the moon on my side?",
]
